import classNames from 'classnames';

const DividerWithText = ({ className, ...dividerProps }) => {
  const dividerClassName = classNames(className);
  return <div className={dividerClassName} {...dividerProps} />;
};

export default DividerWithText;
